const API_BASE_URL = process.env.REACT_APP_API_URL;
//const API_BASE_URL = "https://c2svc.iresoft.cz:9128/irebookmap/api";

const API_ROUTES = {
  place: {
    getAll: `${API_BASE_URL}/places`,
    getAllWithImages: `${API_BASE_URL}/places?withImages=true`,
    getNewest: `${API_BASE_URL}/places/newest`,
    create: `${API_BASE_URL}/places`,
    delete: `${API_BASE_URL}/places`,
    getById: (id: string) => `${API_BASE_URL}/places/${id}`,
    update: (id: string) => `${API_BASE_URL}/places/${id}`,
  },
};

export default API_ROUTES;
